import type { SupportedLocale } from '@erp/shared';
const de = {
  senderHelp: 'Hilfe zur Absenderauswahl',
  invalidRecipients: 'Bitte alle Empfänger einschließlich BCC prüfen.',
  captureUnavailable:
    'Der geschützte Versandnachweis ist noch nicht verfügbar. Bitte später erneut versuchen.',
  recordPending:
    'Die E-Mail wurde angenommen. Der Belegstatus konnte nicht gespeichert werden. Bitte den Nachweis prüfen und nicht erneut senden.',
  rejected: 'Der Versand wurde abgelehnt. Bitte Empfänger und Versandkonfiguration prüfen.',
  sender: 'Absender wählen',
  defaultSender: 'Standardversand des Mandanten',
  bcc: 'BCC (vertraulich)',
  protected: 'BCC bleibt geschützt. Eine Zuordnung gibt weitere Empfänger nicht automatisch frei.',
  loadFailed: 'Absender konnten nicht geladen werden. Standardversand bleibt verfügbar.',
  noSenders: 'Keine weiteren freigegebenen Absender verfügbar.',
  uncertain: 'Die Zustellung ist unklar. Bitte den Versandnachweis prüfen und nicht erneut senden.',
  partial:
    'Nur ein Teil der Empfänger wurde angenommen. Bitte den Versandnachweis prüfen, bevor du erneut sendest.',
  pending:
    'Die E-Mail wurde angenommen. Die Ablage wird wiederhergestellt. Bitte nicht erneut senden.',
  alreadySubmitted: 'Dieser Versand wurde bereits übergeben. Bitte den Versandnachweis prüfen.',
};
export const centralMailOutboundTranslations = {
  de,
  en: {
    senderHelp: 'Help with choosing a sender',
    invalidRecipients: 'Check all recipients, including BCC.',
    captureUnavailable: 'Protected delivery evidence is not available yet. Please try again later.',
    recordPending:
      'The email was accepted. The document status could not be saved. Check the evidence and do not send again.',
    rejected: 'Delivery was rejected. Check the recipients and delivery configuration.',
    sender: 'Choose sender',
    defaultSender: 'Tenant default delivery',
    bcc: 'BCC (confidential)',
    protected:
      'BCC stays protected. Matching does not automatically share mail with other recipients.',
    loadFailed: 'Senders could not be loaded. Default delivery remains available.',
    noSenders: 'No other approved senders are available.',
    uncertain: 'Delivery is uncertain. Check the delivery evidence and do not send again.',
    partial:
      'Only some recipients were accepted. Check the delivery evidence before sending again.',
    pending: 'The email was accepted. Archiving is being recovered. Do not send again.',
    alreadySubmitted: 'This delivery has already been submitted. Check its delivery evidence.',
  },
  fr: {
    senderHelp: 'Aide au choix de l’expéditeur',
    invalidRecipients: 'Vérifiez tous les destinataires, y compris les CCI.',
    captureUnavailable:
      'La preuve d’envoi protégée n’est pas encore disponible. Réessayez plus tard.',
    recordPending:
      'Le message a été accepté. Le statut du document n’a pas pu être enregistré. Vérifiez la preuve et ne renvoyez pas le message.',
    rejected: 'L’envoi a été refusé. Vérifiez les destinataires et la configuration d’envoi.',
    sender: 'Choisir l’expéditeur',
    defaultSender: 'Envoi par défaut de l’entreprise',
    bcc: 'CCI (confidentiel)',
    protected:
      'Les CCI restent protégés. Une correspondance ne partage pas automatiquement le message avec les autres destinataires.',
    loadFailed: 'Impossible de charger les expéditeurs. L’envoi par défaut reste disponible.',
    noSenders: 'Aucun autre expéditeur autorisé disponible.',
    uncertain:
      'La remise est incertaine. Vérifiez la preuve d’envoi et ne renvoyez pas le message.',
    partial:
      'Seuls certains destinataires ont été acceptés. Vérifiez la preuve d’envoi avant tout nouvel envoi.',
    pending:
      'Le message a été accepté. L’archivage est en cours de récupération. Ne le renvoyez pas.',
    alreadySubmitted: 'Cet envoi a déjà été soumis. Vérifiez sa preuve d’envoi.',
  },
  es: {
    senderHelp: 'Ayuda para elegir remitente',
    invalidRecipients: 'Revise todos los destinatarios, incluidos los CCO.',
    captureUnavailable: 'La prueba de envío protegida aún no está disponible. Inténtelo más tarde.',
    recordPending:
      'El mensaje fue aceptado. No se pudo guardar el estado del documento. Revise la prueba y no vuelva a enviarlo.',
    rejected: 'El envío fue rechazado. Revise los destinatarios y la configuración de envío.',
    sender: 'Elegir remitente',
    defaultSender: 'Envío predeterminado de la empresa',
    bcc: 'CCO (confidencial)',
    protected:
      'Los CCO quedan protegidos. Una coincidencia no comparte automáticamente el mensaje con otros destinatarios.',
    loadFailed: 'No se pudieron cargar los remitentes. El envío predeterminado sigue disponible.',
    noSenders: 'No hay otros remitentes autorizados disponibles.',
    uncertain: 'La entrega es incierta. Revise la prueba de envío y no vuelva a enviar el mensaje.',
    partial:
      'Solo se aceptaron algunos destinatarios. Revise la prueba de envío antes de volver a enviar.',
    pending: 'El mensaje fue aceptado. Se está recuperando el archivo. No vuelva a enviarlo.',
    alreadySubmitted: 'Este envío ya se ha presentado. Revise su prueba de envío.',
  },
  tr: {
    senderHelp: 'Gönderen seçimi yardımı',
    invalidRecipients: 'Gizli alıcılar dahil tüm alıcıları kontrol edin.',
    captureUnavailable:
      'Korumalı gönderim kanıtı henüz kullanılamıyor. Lütfen daha sonra tekrar deneyin.',
    recordPending:
      'E-posta kabul edildi. Belge durumu kaydedilemedi. Kanıtı kontrol edin ve yeniden göndermeyin.',
    rejected: 'Gönderim reddedildi. Alıcıları ve gönderim yapılandırmasını kontrol edin.',
    sender: 'Gönderen seç',
    defaultSender: 'Şirketin varsayılan gönderimi',
    bcc: 'Gizli (BCC)',
    protected: 'Gizli alıcılar korunur. Eşleştirme, iletiyi diğer alıcılarla otomatik paylaşmaz.',
    loadFailed: 'Gönderenler yüklenemedi. Varsayılan gönderim kullanılabilir.',
    noSenders: 'Başka onaylı gönderen bulunmuyor.',
    uncertain: 'Teslimat belirsiz. Gönderim kanıtını kontrol edin ve yeniden göndermeyin.',
    partial:
      'Yalnızca bazı alıcılar kabul edildi. Yeniden göndermeden önce gönderim kanıtını kontrol edin.',
    pending: 'E-posta kabul edildi. Arşiv kaydı kurtarılıyor. Yeniden göndermeyin.',
    alreadySubmitted: 'Bu gönderim zaten iletildi. Gönderim kanıtını kontrol edin.',
  },
} satisfies Record<SupportedLocale, Record<keyof typeof de, string>>;
